module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiByp8kv8JHgFVrLDz8Z11lFd2JQEl8qw.ee36c39c.woff2";